import { Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy } from '@angular/core';
@Pipe({
    name: 'calculatedRowTotal',
    pure: false
})
export class CalculatedRowTotalPipe implements PipeTransform {
    constructor() { }
    transform(item: any, array: any[], skip: number = 0, take: number = 0, key: string) {
        const data = array.slice(skip, take);
        const sum = data.reduce((a, b) => a + (b[key] ? +b[key] ?? 0 : 0), 0);
        if (key) item[key] = sum;
        return sum;
    }
}
